import React from 'react';

// Same greeting treatment as an empty ordinary chat (ChatAgentPanel's
// .chat-wow-greeting), so a new planning thread does not introduce a
// second, paler empty-state style.
export default function PlanningChatEmptyState({ line }) {
  return (
    <div className="chat-agent-wow-empty-state">
      <h1 className="chat-wow-greeting">{line}</h1>
    </div>
  );
}
